import React from "react";
import { Building2, Loader2 } from "lucide-react";

interface Trade {
  id: string;
  name: string;
}

interface BusinessUnitMatcherProps {
  mappingId: string;
  businessUnitName: string;
  tradeId: string;
  trades: Trade[];
  onMappingChange: (
    mappingId: string,
    field: "businessUnitId" | "tradeId",
    value: string,
  ) => void;
  isSaving?: boolean;
}

const BusinessUnitMatcher: React.FC<BusinessUnitMatcherProps> = ({
  mappingId,
  businessUnitName,
  tradeId,
  trades,
  onMappingChange,
  isSaving = false,
}) => {
  return (
    <tr>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <Building2 className="h-5 w-5 text-gray-400 mr-3" />
          <div className="text-sm font-medium text-gray-900">
            {businessUnitName}
          </div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <select
            className="ml-2 block w-full max-w-xs rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            onChange={(e) =>
              onMappingChange(mappingId, "tradeId", e.target.value)
            }
            value={tradeId}
          >
            <option value="">Choose trade...</option>
            {trades.map((trade) => (
              <option key={trade.id} value={trade.id}>
                {trade.name}
              </option>
            ))}
          </select>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm">
        <div className="flex items-center space-x-2">
          {isSaving && (
            <div className="flex items-center text-green-600">
              <Loader2 className="h-4 w-4 animate-spin mr-1" />
              <span className="text-xs">Saving...</span>
            </div>
          )}
        </div>
      </td>
    </tr>
  );
};

export default BusinessUnitMatcher;
